import React, { useState, useEffect, Fragment } from 'react';
import axios from 'axios';
import Dashboard from '../Admin/Dashboard/Dashboard';
import baseApi from '../api';
import { Link, useParams } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Helmet } from 'react-helmet';
import ImageWebp from '../../ImageWebp';
import CurrentDate from '../Admin/CurrentDate';
import Loader from '../Admin/Dashboard/Loader';
import Select from 'react-select';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import CKTextEditor from '../Editor';

const Myswal = withReactContent(Swal);

const EditCaseStudy = (props) => {
  const [state, setState] = useState({
    b_title: '',
    b_description: '',
    image: [],
    page_title: '',
    page_description: '',
    keyword: '',
    title: 'Edit Case Study',
    tempImg: [],
    updatedImage: '',
    loading: true,
    category_options: [],
    industry_options: [],
    author_options: [],
    category: [],
    categoryErr: '',
    industry: [],
    industryErr: '',
    initialCategory: [],
    initialIndustry: [],
    slug: '',
    slugErr: '',
    initialSlug: '',
    createdAt: '',
    status: 'publish'
  });

  const toDatetimeLocal = (value) => {
    if (!value) return '';
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return '';
    const pad = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
  };

  const { id } = useParams();

  const modules = {
    toolbar: [[{ header: [1, 2, 3, 4, 5, 6, false] }], ['bold', 'italic', 'underline', 'blockquote', 'code-block'], ['link'], [{ list: 'ordered' }, { list: 'bullet' }], ['image'], [{ color: [] }, { background: [] }], [{ font: [] }], [{ align: [] }]]
  };

  const formats = ['header', 'bold', 'italic', 'underline', 'blockquote', 'code-block', 'font', 'size', 'list', 'bullet', 'align', 'color', 'background', 'link', 'image', 'video'];

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch categories
        const categoryRes = await axios.get(`${baseApi}case-study/get-case-study-categories`);
        const tempCategory = categoryRes.data.data.map((item) => ({
          label: item.category,
          value: item.slug
        }));

        // Update category options in state
        setState((prevState) => ({
          ...prevState,
          category_options: tempCategory
        }));

        // Fetch industries
        const industryRes = await axios.get(`${baseApi}case-study/get-case-study-industries`);
        const tempIndustry = industryRes.data.data.map((item) => ({
          label: item.industry,
          value: item.slug
        }));

        // Update industry options in state
        setState((prevState) => ({
          ...prevState,
          industry_options: tempIndustry
        }));

        // Fetch case study by ID
        const response = await axios.get(`${baseApi}case-study/get-case-study-by-id/${id}`);
        const data = response.data.data;

        setState((prevState) => ({
          ...prevState,
          b_title: data.b_title,
          b_description: data.b_description,
          page_title: data.page_title,
          page_description: data.page_description,
          keyword: data.keyword,
          image: data.image,
          tempImg: data.image,
          slug: data.slug,
          initialSlug: data.slug,
          createdAt: toDatetimeLocal(data.createdAt),
          status: data.status || prevState.status,
          loading: false,
          category: data.case_study_category?.map((item) => tempCategory.find((ele) => ele.value === item)),
          industry: data.case_study_industry?.map((item) => tempIndustry.find((ele) => ele.value === item))
        }));
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, [id]);

  const checkSlug = (slug) => {
    axios
      .post(
        baseApi + 'case-study/check-slug',
        { slug: slug },
        {
          headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('jwtToken')}`
          }
        }
      )
      .then((res) => {
        setState((prevState) => ({
          ...prevState,
          slugErr: ''
        }));
      })
      .catch((error) => {
        setState((prevState) => ({
          ...prevState,
          slugErr: error.response.data.error || 'Slug is invalid'
        }));
      });
  };

  const onchangeb_title = (e) => {
    setState((prevState) => ({
      ...prevState,
      b_title: e.target.value
    }));
  };

  const onchangeb_description = (value) => {
    setState((prevState) => ({
      ...prevState,
      b_description: value
    }));
  };

  const onchangeCategory = (value) => {
    // const newValues = value.map((item) => item.label);
    setState((prevState) => ({
      ...prevState,
      category: value,
      categoryErr: ''
    }));
  };

  const onchangeIndustry = (value) => {
    setState((prevState) => ({
      ...prevState,
      industry: value,
      industryErr: ''
    }));
  };

  const onchangeImage = (e) => {
    const file = e.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onloadend = () => {
        setState((prevState) => ({
          ...prevState,
          image: file,
          updatedImage: file,
          base64Image: reader.result,
          tempImg: reader.result
        }));
      };

      reader.readAsDataURL(file);
    }
  };

  const onchangePageTitle = (e) => {
    setState((prevState) => ({
      ...prevState,
      page_title: e.target.value
    }));
  };

  const debounce = (func, delay) => {
    let timerId;
    return (...args) => {
      clearTimeout(timerId);
      timerId = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  };

  const debouncedCheckSlug = debounce(checkSlug, 1000);

  const onchangeSlug = (e) => {
    setState((prevState) => ({
      ...prevState,
      slug: e.target.value
    }));

    if (state.initialSlug !== e.target.value) {
      debouncedCheckSlug(e.target.value);
    }
  };

  const onchangePageDes = (e) => {
    setState((prevState) => ({
      ...prevState,
      page_description: e.target.value
    }));
  };

  const onchangeKeyword = (e) => {
    setState((prevState) => ({
      ...prevState,
      keyword: e.target.value
    }));
  };

  const onchangeAuthorName = (e) => {
    setState((prevState) => ({
      ...prevState,
      author_name: e.target.value
    }));
  };

  const onchangeCreatedAt = (e) => {
    setState((prevState) => ({
      ...prevState,
      createdAt: e.target.value
    }));
  };

  const onchangeStatus = (e) => {
    setState((prevState) => ({
      ...prevState,
      status: e.target.value
    }));
  };

  const onSubmit = (e) => {
    e.preventDefault();
    setState((prevState) => ({
      ...prevState,
      loading: true
    }));

    const fd = new FormData();
    fd.append('case_study_id', id);
    fd.append('b_title', state.b_title);
    fd.append('b_description', state.b_description);
    fd.append('page_title', state.page_title);
    fd.append('page_description', state.page_description);
    fd.append('keyword', state.keyword);

    if (state.updatedImage) {
      fd.append('image', state.updatedImage);
    }

    if (state.slug) {
      fd.append('slug', state.slug);
    }

    if (state.category) {
      fd.append('case_study_category', JSON.stringify(state.category.map((item) => item.value)));
    }

    if (state.industry) {
      fd.append('case_study_industry', JSON.stringify(state.industry.map((item) => item.value)));
    }

    fd.append('status', state.status);
    if (state.createdAt) {
      fd.append('createdAt', new Date(state.createdAt).toISOString());
    }

    const config = {
      headers: {
        'content-type': 'multipart/form-data',
        Authorization: `Bearer ${localStorage.getItem('jwtToken')}`
      }
    };

    axios
      .put(`${baseApi}case-study/update-case-study`, fd, config) // vishal
      .then((res) => {
        setState((prevState) => ({
          ...prevState,
          loading: false
        }));
      })
      .catch((error) => {
        setState((prevState) => ({
          ...prevState,
          loading: false
        }));
        Myswal.fire({
          title: 'Something went wrong.',
          text: error?.response?.data?.message || 'Server Error',
          type: 'error'
        });
      });
  };

  let image = state.tempImg;
  let isLoading = state.loading;
  let author_image = state.author_image_temp;

  const hStyle = { color: 'red' };
  return (
    <Fragment>
      {!isLoading ? (
        <div className="admin_panel">
          <Helmet>
            <title>{state.page_title} | Dean Infotech Pvt. Ltd.</title>
            <meta id="meta-description" name="description" content={state.page_description} />
            <meta id="og-keywords" name="keywords" property="og:keywords" content={state.keyword} />
            <meta id="og-title" property="og:title" content={state.page_title} />
          </Helmet>
          <Dashboard />

          <div className="container">
            <div className="col-sm-12">
              <CurrentDate />
              <form onSubmit={onSubmit} encType="multipart/form-data" className="form">
                <div className="form-group">
                  <label>
                    <h3>Title</h3>
                  </label>
                  <input type="text" className="form-control" value={state.b_title} onChange={onchangeb_title} />
                </div>

                <div className="form-group">
                  <label>
                    <h3>Slug</h3>
                  </label>
                  <input type="text" style={{ textTransform: 'lowercase' }} className="form-control" value={state.slug} onChange={onchangeSlug} />
                  <span style={hStyle}>{state.slugErr}</span>
                </div>

                <div className="form-group">
                  <label>
                    <h4>Description</h4>
                  </label>
                  <CKTextEditor value={state.b_description} onChange={onchangeb_description} />
                </div>

                <div className="form-group">
                  <label>
                    <h3>Category</h3>
                  </label>
                  <Select defaultValue={state.category} isMulti name="colors" options={state.category_options} className="form-Control select-search basic-multi-select" classNamePrefix="select" value={state.category} onChange={onchangeCategory} />
                  <span style={hStyle}>{state.categoryErr}</span>
                </div>

                <div className="form-group">
                  <label>
                    <h3>Industry</h3>
                  </label>
                  <Select defaultValue={state.industry} isMulti name="colors" options={state.industry_options} className="form-Control select-search basic-multi-select" classNamePrefix="select" value={state.industry} onChange={onchangeIndustry} />
                  <span style={hStyle}>{state.industryErr}</span>
                </div>

                <div className="form-group">
                  <label>
                    <h4>Image</h4>
                  </label>
                  <input type="file" className="form-Control" onChange={onchangeImage} name="Image" accept="image/*" />
                  <ImageWebp srcWebp={image} src={image} className="mt-2" height="80px" width="100px" />
                </div>
                <div className="form-group">
                  <label>
                    <h3>Status</h3>
                  </label>
                  <select className="form-control" value={state.status} onChange={onchangeStatus}>
                    <option value="draft">Draft</option>
                    <option value="publish">Publish</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>
                    <h3>Created Date</h3>
                  </label>
                  <input type="datetime-local" className="form-control" value={state.createdAt} onChange={onchangeCreatedAt} />
                </div>
                <div className="form-group">
                  <label>
                    <h3>Page Title</h3>
                  </label>
                  <input type="text" className="form-control" value={state.page_title} onChange={onchangePageTitle} />
                </div>
                <div className="form-group">
                  <label>
                    <h3>Page Description</h3>
                  </label>
                  <textarea className="form-control" value={state.page_description} onChange={onchangePageDes}></textarea>
                </div>
                <div className="form-group">
                  <label>
                    <h3>Keywords</h3>
                  </label>
                  <input type="text" className="form-control" value={state.keyword} onChange={onchangeKeyword} />
                </div>

                <div className="form-group">
                  <input type="submit" className="btn btn-primary" value="Update Case Study" />
                  &nbsp;&nbsp;
                  <Link to="/case-studies">Back to Case Study</Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      ) : (
        <Loader />
      )}
    </Fragment>
  );
};

export default EditCaseStudy;
